import { createRoot } from 'react-dom/client';
import React from 'react';

import App from './App';
import Card from './components/AgendaContent/Card';
import config from './Config';

if (document.body.contains(document.querySelector('.js_react_filter'))) {
	document.querySelectorAll(".js_react_filter").forEach((filter, index) => {
		const root = createRoot(filter); // createRoot is now used
		root.render(<App key={index} config={config} rootElement={filter} />);
	});
}

if (document.body.contains(document.querySelector('.js_react_tile'))) {
	document.querySelectorAll('.js_react_tile').forEach((tile, index) => {
		let event = Object.values(JSON.parse(decodeURIComponent(tile.dataset.event)))[0];

		const root = createRoot(tile); // createRoot is now used here as well
		root.render(
			<Card
				element={event}
				config={config.goudse}
				setTagsParam={() => {}}
			/>
		);
	});
}
